import { ReactNode } from 'react';

import ResultPopup from './content/containers/ResultPopup';
import { useContextSelector } from './context/hooks';
import Connection from './content';

const LayoutSwitcher = ({ children }: { children: ReactNode }): JSX.Element => {
    const isShowSpeedBonusConnection = useContextSelector(state => state.isShowConnection);

    return (
        <>
            {isShowSpeedBonusConnection
                ? <Connection/>
                : children
            }
            <ResultPopup/>
        </>
    );
};

export default LayoutSwitcher;
